module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Prelims-new-page",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Trigger warning:")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The following content suggests and hints to some sensitive topics.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5edc10a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035801855_EPUB-4.vue
// module id = 69
// module chunks = 0